var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VsChip',{staticClass:"m-0",class:{ 'text-green-600': _vm.statusColor === 'success' },attrs:{"color":_vm.statusColor,"transparent":""}},[(_vm.isClosed)?_c('VsAvatar',{class:{
      'bg-blue-400': _vm.statusColor === 'primary',
      'bg-green-400': _vm.statusColor === 'success',
      'bg-indigo-400': _vm.statusColor === '#2E53B4',
      'bg-purple-500': _vm.statusColor === '#9C26D4'
    },attrs:{"icon":"done","color":_vm.statusColor === 'dark' ? '#888888' : ''}}):(_vm.invoice.isPrepaid)?_c('VsAvatar',{staticClass:"bg-red-400",attrs:{"icon":"priority_high"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }